export default {
  namespaced: true,
  state () {
    return {
      address: '',
      coords: []
    }
  }
}
